<template>
    <!-- eslint-disable -->
    <decorator-icon v-bind="attrs">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M16 30.6667C7.8998 30.6667 1.33331 24.1002 1.33331 16C1.33331 7.89982 7.8998 1.33333 16 1.33333C24.1002 1.33333 30.6666 7.89982 30.6666 16C30.6666 24.1002 24.1002 30.6667 16 30.6667ZM16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 3.99999 16 3.99999C9.37256 3.99999 3.99998 9.37258 3.99998 16C3.99998 22.6274 9.37256 28 16 28ZM13.3333 18.1144L20.3905 11.0572L22.2761 12.9428L13.3333 21.8856L8.3905 16.9428L10.2761 15.0572L13.3333 18.1144Z"
              fill="#4EBC50"/>
    </decorator-icon>
</template>

<script>
import DecoratorIcon from '../decorator/dp-icon-decorator'
import MixinIcon from '../mixin/dp-icon-mixin'

export default {
  name: 'dp-check-icon',
  mixins: [MixinIcon],
  components: {
    DecoratorIcon
  },
  data() {
    return {
      viewBox: '0 0 32 32'
    }
  }
}
</script>
